import { jsxs, jsx } from "react/jsx-runtime";
import { Box, Text } from "@zillow/constellation-10";
import { getWholeDollars } from "../../utils/zhl-calculator.esm.js";
import { useLastValidRefinanceValues, useRefinanceColors } from "./RefinanceCalculator.utils.esm.js";
const LoanProgramLabel = ({
  color
}) => /* @__PURE__ */ jsx(Box, { css: {
  marginRight: "tighter"
}, children: /* @__PURE__ */ jsx("svg", { width: "8", height: "8", children: /* @__PURE__ */ jsx("circle", { cx: "4", cy: "4", r: "4", fill: color }) }) });
const RefinanceLegend = ({
  className
}) => {
  const values = useLastValidRefinanceValues();
  const colors = useRefinanceColors();
  return /* @__PURE__ */ jsxs("div", { className, children: [
    /* @__PURE__ */ jsxs(Box, { css: {
      display: "flex",
      justifyContent: "space-between"
    }, children: [
      /* @__PURE__ */ jsx(Text, { textStyle: "body-bold", children: "Monthly savings" }),
      /* @__PURE__ */ jsxs(Text, { children: [
        getWholeDollars(values.calculations.monthlySavings),
        " /mo"
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Box, { css: {
      display: "flex",
      justifyContent: "space-between"
    }, children: [
      /* @__PURE__ */ jsx(Text, { textStyle: "body-bold", children: "New payment" }),
      /* @__PURE__ */ jsx(Text, { children: getWholeDollars(values.calculations.newPayment) })
    ] }),
    /* @__PURE__ */ jsxs(Box, { css: {
      display: "flex",
      justifyContent: "space-between"
    }, children: [
      /* @__PURE__ */ jsx(Text, { textStyle: "body-bold", children: "Break even" }),
      values.calculations.breakEven && /* @__PURE__ */ jsxs(Text, { children: [
        values.calculations.breakEven,
        " ",
        values.calculations.breakEven === 1 ? "month" : "months"
      ] }),
      !values.calculations.breakEven && /* @__PURE__ */ jsx(Text, { children: "N/A" })
    ] }),
    /* @__PURE__ */ jsxs(Box, { css: {
      display: "flex",
      justifyContent: "space-between"
    }, children: [
      /* @__PURE__ */ jsxs(Text, { textStyle: "body-bold", css: {
        display: "flex",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ jsx(LoanProgramLabel, { color: colors.costsColor }),
        "Costs"
      ] }),
      /* @__PURE__ */ jsx(Text, { children: getWholeDollars(values.fields.fees) })
    ] }),
    /* @__PURE__ */ jsxs(Box, { css: {
      display: "flex",
      justifyContent: "space-between"
    }, children: [
      /* @__PURE__ */ jsxs(Text, { textStyle: "body-bold", css: {
        display: "flex",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ jsx(LoanProgramLabel, { color: colors.lifetimeSavingsColor }),
        "Lifetime savings"
      ] }),
      /* @__PURE__ */ jsx(Text, { children: getWholeDollars(values.calculations.lifetimeSavings) })
    ] })
  ] });
};
export {
  RefinanceLegend as default
};
